module.exports = __webpack_public_path__ + "static/media/service-bg5.0e54a3d8.jpg";